import DashboardGenComponent from "@/components/DashboardGenComponent.tsx";
import st from "@/styles/Success.module.scss"
import {useTranslation} from "react-i18next";
import {CircularProgress} from "@mui/material";
import CommonClass from "@/utils/common";
import Button from "@/ui/Button.tsx";
import DashboardClass from "@/utils/dashboard_class";
import {useNavigate, useParams} from "react-router-dom";
import Images from "@/utils/images.ts";
import {useEffect} from "react";
import useLoans from "@/hooks/loans.ts";

const SuccessOpenCrLine = () => {
    const {t} = useTranslation()
    const l = t("currency")
    const dc = DashboardClass
    const navigate = useNavigate();
    const {urn} = useParams();
    const loans = useLoans()
    const cr_line_loans = loans.getLoansByType("Credit Line")

    const current_cr_line = cr_line_loans?.find(item => item?.urn === urn)

    useEffect(() => {
        if(Array.isArray(cr_line_loans)) {
            let timeout = setTimeout(() => {
                if(!current_cr_line) {

                    navigate(dc.dashboard_routes.CreditLine)

                } else {
                    loans.updateUserLoans()
                }

                clearTimeout(timeout)
            }, 1000)
        }

    }, [cr_line_loans]);


    return typeof current_cr_line === "object" && (
        <DashboardGenComponent
            header_type={"primary"}
            heading={<></>}
            responsive1
            column_center={
                <div className={st.column_center}>
                    <div className={st.heading}>
                        <strong className={st.success_text}>
                            {t("success")}
                        </strong>

                        <p>
                            {t("sign_cr_line_success_confirm")}
                        </p>
                    </div>

                    <div className={st.content}>
                        {typeof current_cr_line === "object" ? (
                            <div className={st.columns}>
                                <div className={st.col}>
                                    <span>
                                        {t("cr_line_amount")}
                                    </span>
                                    <strong>
                                        {current_cr_line?.capital && CommonClass.formatMoneyAmount(Number(current_cr_line?.capital))} {l}
                                    </strong>
                                </div>
                            </div>
                        ) : (
                            <CircularProgress
                                sx={{
                                    display: "block",
                                    color: "#000",
                                }}
                            />
                        )}
                    </div>

                    <div className={st.controllers}>
                        <Button
                            light
                            onClick={() => {
                                navigate(dc.dashboard_routes.CreditLine + `/${urn}`)
                            }}
                        >
                            {t("see_cr_line_details")}
                        </Button>
                        <Button
                            onClick={() => {
                                navigate(dc.dashboard_routes.Home)
                            }}
                            light
                            outlined
                            className={st.outlined_btn}
                        >
                            {t("dashboard_home")}
                        </Button>
                    </div>
                </div>
            }
            full_bg
            corner_image={
                <img
                    className={st.bg_image}
                    src={Images.logos.Success}
                    alt={"success"}
                    width={557}
                    height={557}
                />
            }
        />
    )}

export default SuccessOpenCrLine